import { IClauseInTopicContext } from "@/api/topics";
import { Box, Paper, Stack, Typography } from "@mui/material";

interface ChecklistClausesListProps {
    clauses: IClauseInTopicContext[];
}

/**
 * Displays a list of clauses from a topic section.
 * Styled to match ScopeTopicsV2 V2ClauseCard pattern.
 * Shows clause title (primary color) and description.
 */
export const ChecklistClausesList = ({
    clauses,
}: ChecklistClausesListProps) => {
    if (clauses.length === 0) {
        return null;
    }

    return (
        <Stack
            gap={0}
            divider={<Box sx={{ borderBottom: 1, borderColor: "divider" }} />}
        >
            {clauses.map((clause) => (
                <Paper
                    key={clause.topic_clause_id}
                    elevation={0}
                    sx={{
                        p: 2,
                        borderRadius: 0,
                    }}
                >
                    <Stack gap={1.5}>
                        {/* Clause header with title */}
                        <Typography
                            variant="body2"
                            fontWeight="bold"
                            color="primary"
                            sx={{ textDecoration: "underline" }}
                        >
                            {clause.title}
                        </Typography>

                        {/* Clause description */}
                        {clause.description && (
                            <Typography
                                variant="body2"
                                color="text.secondary"
                                sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    WebkitLineClamp: 3,
                                    WebkitBoxOrient: "vertical",
                                }}
                            >
                                {clause.description}
                            </Typography>
                        )}
                    </Stack>
                </Paper>
            ))}
        </Stack>
    );
};
